module.exports = __webpack_public_path__ + "static/media/TubeRotor.607145e8.svg";